import { IPriceLiteProps } from './priceLite.models';
import {
  Detail,
  DetailsContainer,
  OriginalPrice,
  Price,
  PriceContainer,
  PriceLabel,
  PriceWrapper,
} from './priceLite.style';

const PriceLite = ({ price, priceLabel, originalPrice, recurrence }: IPriceLiteProps) => {
  const priceWithoutRec = price?.replace('€', '');
  const priceSplitted = priceWithoutRec?.split(',');

  const getDetail = () => {
    if (priceSplitted?.length === 1) {
      return <Detail>€</Detail>;
    }
    return <Detail>,{priceSplitted?.[1]}€</Detail>;
  };

  return (
    <PriceWrapper>
      {priceLabel && <PriceLabel>{priceLabel}</PriceLabel>}
      {originalPrice && <OriginalPrice>{originalPrice}</OriginalPrice>}
      <PriceContainer>
        <Price>{priceSplitted[0]}</Price>
        <DetailsContainer>
          {getDetail()}
          {recurrence && <Detail>{`/${recurrence}`}</Detail>}
        </DetailsContainer>
      </PriceContainer>
    </PriceWrapper>
  );
};

export default PriceLite;
